// 功能模块管理 
import http from '../httpConfig'
// 高级参照业务列表
export const getBusinessList = (prompt_name) => {
  const params = {
    prompt_name,
    "~table~": 'mrbase_sys_prompt'
  }
  return new Promise((resolve, reject) => {
    http.post('/api/prompt/business/findPrompt/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 模块功能列表列表查询
// mrbase_sys_modules 模块表
export const get_list = (params = {}) => {
  params['~table~'] = 'mrbase_sys_modules'
  // Object.assign(params, { '~table~': 'mrbase_sys_modules' })
  return new Promise((resolve, reject) => {
    http.post('/api/modules/list-module/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 模块查询
// mrbase_sys_modules 模块表
export const get_detail = (params = {}) => {
  params['~table~'] = 'mrbase_sys_modules'
  return new Promise((resolve, reject) => {
    http.post('/api/modules/find-moduleInfo/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 模块修改
export const get_update = (params = {}) => {
  params['~table~'] = 'mrbase_sys_modules'
  return new Promise((resolve, reject) => {
    http.post('/api/modules/update-module/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 模块新增
export const get_add = (params = {}) => {
  params['~table~'] = 'mrbase_sys_modules'
  return new Promise((resolve, reject) => {
    http.post('/api/modules/add-module/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 模块删除
export const get_del = (params = {}) => {
  params['~table~'] = 'mrbase_sys_modules'
  return new Promise((resolve, reject) => {
    http.post('/api/modules/delete-module/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// mrbase_sys_functions 功能表名

// 新增功能
export const get_func_add = (params = {}) => {
  params['~table~'] = 'mrbase_sys_functions'
  return new Promise((resolve, reject) => {
    http.post('/api/functions/add-functions/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 功能修改
export const get_func_update = (params = {}) => {
  params['~table~'] = 'mrbase_sys_functions'
  return new Promise((resolve, reject) => {
    http.post('/api/functions/update-function/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 功能删除
export const get_func_del = (params = {}) => {
  params['~table~'] = 'mrbase_sys_functions'
  return new Promise((resolve, reject) => {
    http.post('/api/functions/delete-function/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 功能详情
export const get_func_detail = (params = {}) => {
  params['~table~'] = 'mrbase_sys_functions'
  return new Promise((resolve, reject) => {
    http.post('/api/functions/find-function/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 获取版本 只有两个版本
export const get_versions = (params = {}) => {
  params['~table~'] = 'mrbase_sys_functions'
  return new Promise((resolve, reject) => {
    http.post('/api/functions/find-version/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 升级按钮版本
export const up_versions = (params = {}) => {
  params['~table~'] = 'mrbase_sys_function_buttons'
  return new Promise((resolve, reject) => {
    http.post('/api/button/up-version/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 修改按钮
export const update_buttons = (params = {}) => {
  params['~table~'] = 'mrbase_sys_function_buttons'
  return new Promise((resolve, reject) => {
    http.post('/api/functions/update-button/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
